import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/system/experimental-api/css-theme-variables/css-theme-variables.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
